import { api } from "../api";

export class RecuperacaoSenhaService {
  async solicitarRecuperacao(documento: string) {
    try {
      const response = await api.post("/login/recover/send-email", { documento });

      // Simulando resposta da API - em produção, este ID viria do backend
      return {
        success: true,
        recoveryId: response.data.id,
        email: response.data.email,
      };
    } catch (error) {
      console.error("Erro ao solicitar recuperação:", error);
      throw error;
    }
  }

  async verificarCodigo(recoveryId: string, codigo: string) {
    // Simulação de chamada API para verificar o código
    try {
      const isValid = await api.post("/login/recover/verify-code", {
        id: recoveryId,
        code: codigo,
      });
      
      return { success: Boolean(isValid.data.token), token: isValid.data.token };
    } catch (error:any) {
      console.error("Erro ao verificar código:", error?.response?.data ?? error);
      throw error;
    }
  }

  async definirNovaSenha( novaSenha: string, tmpToken?: string) {
    // Simulação de chamada API para definir nova senha
    try {

      await api.post("/login/recover/reset-password", {
        newPassword: novaSenha,
      },{
        headers:{
          Authorization: `Bearer ${tmpToken}`
        }
      })
        
      // Simulando um tempo de resposta da API
      await new Promise((resolve) => setTimeout(resolve, 1000));

      return { success: true };
    } catch (error) {
      console.error("Erro ao definir nova senha:", error);
      throw error;
    }
  }
}
